import { render, staticRenderFns } from "./DesgravacionImpositiva.vue?vue&type=template&id=3c323cb1"
import script from "./DesgravacionImpositiva.vue?vue&type=script&lang=js"
export * from "./DesgravacionImpositiva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports